module.exports = __webpack_public_path__ + "img/product4.e1c16b43.png";